import {ITheme} from 'contexts/ThemeContext';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  minSize,
} from 'rn-responsive-styles';

export default (props: ITheme) =>
  CreateResponsiveStyle(
    {
      container: {
        flex: 1,
        backgroundColor: props.colors.dirtyWhite,
        flexDirection: 'row',
      },
      flex: {
        flex: 1,
      },
    },
    {
      [minSize(DEVICE_SIZES.SMALL_DEVICE)]: {},
    },
  )();
